module.exports = __webpack_public_path__ + "img/6-7.038ee874.png";